import React from 'react';
import { InputTextarea } from 'primereact/inputtextarea';

function InputTextareaComponent({ id, value, onChange }) {
    return (
        <div className="field grid">
            <label htmlFor={id} className="col-fixed mb-0" style={{ width: '150px' }}>{id}</label>
            <div className="input" style={{ flex: '1' }}>
                <InputTextarea
                    id={id}
                    value={value}
                    onChange={(e) => onChange(e.target.value)}
                    rows={4}
                    className="p-inputtext p-component"
                />
            </div>
        </div>
    );
}

export default InputTextareaComponent;